<template>
  <div
    v-if="isActive"
    class="payment-process"
  >
    <div
      v-if="false"
      class="payment-process-body"
    >
      <h1>Введите данные</h1>
      <p>Вашей банковской карты</p>
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <b-form
          class="payment-form"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Номер карты"
            rules="required"
            vid="card_number"
          >
            <b-form-group
              label="Номер карты"
              label-for="card_number"
            >
              <b-form-input
                id="card_number"
                v-model="paymentData.card_number"
                trim
                placeholder="5637 8172 1290"
                :state="getValidationState(validationContext)"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <b-row>
            <b-col cols="6">
              <validation-provider
                #default="validationContext"
                name="Имя Фамилия"
                rules="required"
                vid="card_holder"
              >
                <b-form-group
                  label="Имя Фамилия"
                  label-for="card_holder"
                >
                  <b-form-input
                    id="card_holder"
                    v-model="paymentData.card_holder"
                    trim
                    placeholder="John Doe"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="3">
              <validation-provider
                #default="validationContext"
                name="Срок действия"
                rules="required"
                vid="card_due"
              >
                <b-form-group
                  label="Срок действия"
                  label-for="card_due"
                >
                  <b-form-input
                    id="card_due"
                    v-model="paymentData.card_due"
                    trim
                    placeholder="MM/YY"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="3">
              <validation-provider
                #default="validationContext"
                name="CVV"
                rules="required"
                vid="card_cvv"
              >
                <b-form-group
                  label="Срок действия"
                  label-for="card_cvv"
                >
                  <b-form-input
                    id="card_cvv"
                    v-model="paymentData.card_cvv"
                    trim
                    placeholder="CVV"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <div>
            <b-form-checkbox
              checked="true"
              name="check-button"
              switch
              inline
            >
              <b class="font-small-3">Сохранить карту</b>
            </b-form-checkbox>
          </div>
          <div class="mt-3 d-flex justify-content-center">
            <b-button
              variant="primary"
              class="mx-1"
              type="submit"
            >
              Оплатить
            </b-button>
            <b-button
              class="mx-1"
              variant="outline-secondary"
              @click="$emit('close')"
            >
              Отмена
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </div>
    <div
      v-if="paymentResult === true">
      <div class="payment-process-body">
        <div class="modal-payment">
          <div class="modal-payment__header">
            <div class="modal-payment__title">
              Оплата прошла успешно
            </div>
          </div>
          <div class="modal-payment__body">
            <p>На вашу электронную почту <span v-if="orderData !== null">({{ orderData.email }})</span> были отправлены
              билеты.</p>
            <p>Билеты можно показать при входе в электронном виде, а также распечатать, открыв файл ниже.</p>
            <div class="my-3">
              <a
                :href="`/orders/${orderId}/tickets?token=${orderToken}`"
                target="_blank"
              >
                <img
                  src="/images/order_pdf.png"
                  style="margin-bottom: 10px;"
                ><br>
                Order_{{ orderId }}.pdf</a>
            </div>
          </div>
          <div class="modal-payment__footer">
            <b-button
              class="btn btn-success"
              @click="reloadPage"
            >
              Купить еще билеты
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="paymentResult === false">
      <div class="payment-process-body">
        <div class="modal-payment">
          <div class="modal-payment__header">
            <div class="modal-attention__title">
              Оплата закончилась ошибкой
            </div>
          </div>
          <div class="modal-payment__footer">
            <a
              href="#"
              class="btn btn-success"
              @click.prevent="reloadPage()"
            >Вернуться к выбору мест</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  BRow, BCol, BButton, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BFormCheckbox,
} from 'bootstrap-vue'
import {ValidationProvider, ValidationObserver, localize} from 'vee-validate'
import ru from 'vee-validate/dist/locale/ru.json'
import {ref} from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import store from '@/store'

localize({ru})
localize('ru')

export default {
  components: {
    BRow,
    BCol,
    BFormCheckbox,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
  },
  emits: ['close'],
  props: {
    orderData: {
      type: Object | null,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    paymentResult: {
      type: Boolean,
      default: null,
    },
    orderId: {
      type: Number,
      default: 0,
    },
    orderToken: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const paymentData = ref({
      card_number: null,
      card_holder: null,
      card_due: null,
      card_cvv: null,
      card_save: 1,
    })
    const step = ref(1)
    // const orderId = ref(null)
    const formData = ref(JSON.parse(JSON.stringify(paymentData)))
    const resetFormData = () => {
      formData.value = JSON.parse(JSON.stringify(paymentData))
    }
    const {refFormObserver, getValidationState, resetForm} = formValidation(resetFormData)
    const onSubmit = () => {
      store.dispatch('widget/makeOrder', {...props.orderData, ...paymentData.value})
        .then(response => {
          // orderId.value = response.data.data.id
          // step.value += 1
        })
    }
    const reloadPage = () => {
      window.location.reload()
    }

    return {
      step,
      paymentData,
      refFormObserver,
      // orderId,
      getValidationState,
      resetForm,
      onSubmit,
      reloadPage,
    }
  },
}
</script>

<style  lang="scss">
$mobile: 899px;
.payment-process {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #ffffff;
  z-index: 20;
  padding: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.payment-process-body {
  text-align: center;
  width: 100%;
  max-width: 480px;
  @media (max-width: $mobile) {
    width: 100%;
    min-width: auto;
  }
}

.payment-form {
  text-align: left;
  margin-top: 2rem;
}

.modal-payment {
  width: 100%;
  padding: 37px 24px;
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);

  &.show {
    display: block;
  }

  &__header {
    margin-bottom: 15px;
    text-align: center;
  }

  &__title {
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    color: #5E5873;
  }

  &__body {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #6E6B7B;
    margin-bottom: 24px;

    p {
      margin: 0 0 16px;
    }
  }

  &__footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
}
</style>
